var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLetterOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    stroke: "#449FDB",
    opacity: ""
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 24c-1.104 0-2-0.896-2-2s0.896-2 2-2c4.412 0 8-3.588 8-8s-3.588-8-8-8c-1.104 0-2-0.896-2-2s0.896-2 2-2c6.616 0 12 5.384 12 12s-5.384 12-12 12z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 120h-70c-6.616 0-12-5.384-12-12s5.384-12 12-12h70c1.1 0 2 0.9 2 2s-0.9 2-2 2c-4.416 0-8 3.584-8 8s3.584 8 8 8c1.1 0 2 0.9 2 2s-0.9 2-2 2zM12.5 100c-4.416 0-8 3.584-8 8s3.584 8 8 8h61.064c-1.904-2.124-3.064-4.928-3.064-8s1.16-5.876 3.064-8h-61.064z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85 120h-5.956c-1.104 0-2-0.9-2-2s0.896-2 2-2h5.956c6.008 0 10.044-5.944 10.044-11.5v-92.5c0-3.040 1.248-5.86 3.26-8h-63.308c-5.528 0-11.956 4.584-11.956 10.5v81.5c0 1.1-0.896 2-2 2s-2-0.9-2-2v-81.5c0-8.544 8.408-14.5 15.956-14.5h72.5c1.1 0 2 0.896 2 2s-0.9 2-2 2c-4.504 0-8.456 3.74-8.456 8v92.5c0.004 8.4-6.432 15.5-14.040 15.5z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.044 24h-20c-1.104 0-2-0.896-2-2s0.896-2 2-2h20c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.044 36h-48c-1.104 0-2-0.896-2-2s0.896-2 2-2h48c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.044 48h-48c-1.104 0-2-0.896-2-2s0.896-2 2-2h48c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.044 60h-48c-1.104 0-2-0.896-2-2s0.896-2 2-2h48c1.104 0 2 0.896 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.044 72h-48c-1.104 0-2-0.9-2-2s0.896-2 2-2h48c1.104 0 2 0.9 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.044 84h-48c-1.104 0-2-0.9-2-2s0.896-2 2-2h48c1.104 0 2 0.9 2 2s-0.896 2-2 2z",
    fill: "#000000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterOpen);
export default __webpack_public_path__ + "static/media/Letter-Open.c2940115.svg";
export { ForwardRef as ReactComponent };